import { createSlice } from "@reduxjs/toolkit";
import { UserState } from "../types";

const initialState: UserState = {
  availableEvents: {
    content: [],
    currentPage: 1,
    size: 10,
    total: 0,
    totalPages: 0
  },
  currentId: "",
  currentForm: {},
  filters: {
    categories: "ALL_CATEGORIES",
    place: "ALL_PLACES",
    speaker: "",
    period: { from: "", to: "" }
  },
  eventTypes: [],
  places: [],
  signupSuccessfull: false,
  signoffSuccessfull: false,
  loading: false,
  token: ""
};

export const userSlice = createSlice({
  name: "userState",
  initialState,
  reducers: {
    getEventSuccess(state: UserState) {
      state.loading = false;
    },
    setEventTypes(state: UserState, action: any) {
      state.eventTypes = action.payload;
    },
    setPlaces(state: UserState, action: any) {
      state.places = action.payload;
    },
    getAllEventsSuccess(state: UserState, action: any) {
      state.availableEvents = action.payload;
      state.loading = false;
    },
    getAllEventsError(state: UserState) {
      state.availableEvents = { content: [], currentPage: 1, size: 10, total: 0, totalPages: 0 };
      state.loading = false;
    },
    setFilter(state: UserState, action: any) {
      state.filters = action.payload;
    },
    setCategory(state: UserState, action: any) {
      state.filters.categories = action.payload;
    },
    setPlace(state: UserState, action: any) {
      state.filters.place = action.payload;
    },
    setSpeaker(state: UserState, action: any) {
      state.filters.speaker = action.payload;
    },
    setPeriodStart(state: UserState, action: any) {
      state.filters.period.from = action.payload;
    },
    setPeriodEnd(state: UserState, action: any) {
      state.filters.period.to = action.payload;
    },
    resetFilter(state: UserState) {
      state.filters = {
        categories: "ALL_CATEGORIES",
        place: "ALL_PLACES",
        speaker: "",
        period: { from: "", to: "" }
      };
    },
    setCurrentId(state: UserState, action: any) {
      state.currentId = action.payload;
    },
    setCurrentForm(state: UserState, action: any) {
      state.currentForm = action.payload;
    },
    signupForEventSuccess(state: UserState) {
      state.signupSuccessfull = true;
    },
    signupForEventError(state: UserState) {
      state.signupSuccessfull = false;
    },
    setSignupSuccessfull(state: UserState, action: any) {
      state.signupSuccessfull = action.payload;
    },
    redirectStart(state: UserState) {
      state.loading = true;
    },
    redirectSuccess(state: UserState, action: any) {
      state.token = action.payload;
      state.loading = false;
    },
    redirectError(state: UserState) {
      state.loading = false;
    },
    setCurrentEvent(state: UserState, action: any) {
      state.currentEvent = action.payload;
    },
    signoffFromEventSuccess(state: UserState, action: any) {
      state.signoffSuccessfull = action.payload;
    },
    reset() {
      return initialState;
    }
  }
});

const { reducer } = userSlice;

export default reducer;
